import(/* webpackMode: "eager" */ "/vercel/path0/fastpeps-core-storefront/src/app/[countryCode]/(main)/contact/page.tsx");
